import Vue from 'vue';

Vue.filter('k_formatter', function(num) {
    return num > 999 ? (num / 1000).toFixed(1) + 'k' : num;
});
